/**
 * @file: RecentVisitedTaskManager.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { asyncStorageSubjectForKey$ } from '@euler/functions/useAsyncStorage';
import { TaskBookmark } from '@euler/model';
import { useBehaviorSubject } from '@euler/utils/hooks';

const kMaxEntries = 100;

export class RecentVisitedTaskManager {
  static readonly shared = new RecentVisitedTaskManager();

  readonly tasks$ = asyncStorageSubjectForKey$<TaskBookmark[]>(
    'recent-visited-tasks',
    undefined,
    { storageType: 'file' },
  );

  add(bookmark: TaskBookmark) {
    const list = [...(this.tasks$.getValue() ?? [])];
    const index = list.findIndex(x => x.taskNo === bookmark.taskNo);
    if (index > 0) {
      // move the item to the front of the list
      list.splice(index, 1);
      list.unshift(bookmark);
      this.tasks$.next(list);
    } else if (index < 0) {
      // otherwise if the item does not exist in the list
      // first trim the list if there are too many entries in the lsit
      // and then insert the item to the front of the list.
      if (list.length >= kMaxEntries) {
        list.pop();
      }
      list.unshift(bookmark);
      this.tasks$.next(list);
    } else {
      // otherwise, the item is already at the front of the list
      // keep it untouched.
    }
  }
}

export const useRecentVisitedTasks = () => {
  const [list] = useBehaviorSubject(RecentVisitedTaskManager.shared.tasks$);
  return list;
};
